import React, { useEffect, useState } from "react";

import { createStore } from "redux";
import { Provider } from "react-redux";
import reducers from "./controllers/store";

import { disableReactDevTools } from "./static/scripts";
//Importing the router
import Router from "./controllers/router";

// Importing the global styles
import "#static/css/fonts.css";
import "#static/css/components.css";
import "#static/css/style.css";
import "#static/css/cadastro.css";
import "#static/css/login.css";
import "#static/css/recover.css";
import MaintenancePage from "#views/MaintenancePage";

const store = createStore(reducers);

const App: React.FC = () => {
  const [isUnderMaintenance, setIsUnderMaintenance] = useState(false);

  useEffect(() => {
    disableReactDevTools();
  }, []);

  if (isUnderMaintenance) {
    return <MaintenancePage />;
  }

  return (
    <div className="App">
      <React.Suspense fallback={<div> Loading... </div>}>
        <Provider store={store}>
          <Router />
        </Provider>
      </React.Suspense>
    </div>
  );
};

export default App;
